import { render, staticRenderFns } from "./TemplateListWebzine.vue?vue&type=template&id=6daeab87&scoped=true&"
import script from "./TemplateListWebzine.vue?vue&type=script&lang=js&"
export * from "./TemplateListWebzine.vue?vue&type=script&lang=js&"
import style0 from "./TemplateListWebzine.vue?vue&type=style&index=0&id=6daeab87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daeab87",
  null
  
)

export default component.exports